<template>
  <div v-if="custom_styles">
    <h4>Custom CSS</h4>
    <ul>
      <li v-for="(css, index) in custom_styles" :key="index"><b-button variant="primary" size="sm" @click="edit(css)"><font-awesome-icon icon="edit" /></b-button> <b-button variant="danger" size="sm" @click="removeAction(css)"><font-awesome-icon icon="trash" /></b-button> | {{css.name}}: {{css.value}} </li>
    </ul>
    <b-input-group>
      <b-input-group-prepend is-text>
        Name
      </b-input-group-prepend>
      <b-form-input type="text" v-model="cssPropName"></b-form-input>
      <b-input-group-prepend is-text>Value</b-input-group-prepend>
      <b-form-input type="text" v-model="cssPropValue"></b-form-input>
      <b-input-group-append>
        <b-button variant="outline-success" @click="add"><font-awesome-icon icon="plus" /></b-button>
      </b-input-group-append>
    </b-input-group>
    <b-input-group>

    </b-input-group>
  </div>
</template>

<script>
import uuidv4 from 'uuid/v4';
import EditorEvents from '../../mixins/editor-events';
import { usePageEditorStore } from '@/stores/PageEditorStore';

export default {
  name: 'PageEditorPropertiesCustomCss',
  mixins: [EditorEvents],
  props: {
    custom_styles: Array,
    properties: Object,
  },
  setup() {
    const pageEditorStore = usePageEditorStore();
    return {
      pageEditorStore,
    };
  },
  data() {
    return {
      cssPropName: null,
      cssPropValue: null,
    };
  },
  methods: {
    removeAction(css) {
      if (css) {
        for (let i = 0; i < this.custom_styles.length; i += 1) {
          const custom = this.custom_styles[i];
          if (custom.uuid === css.uuid) {
            this.custom_styles.splice(i, 1);
            this.update();
            break;
          }
        }
      }
    },
    add() {
      if (this.cssPropName && this.cssPropValue) {
        const obj = { name: this.cssPropName, value: this.cssPropValue, uuid: uuidv4() };

        for (let i = 0; i < this.custom_styles.length; i += 1) {
          const custom = this.custom_styles[i];
          if (custom.name === obj.name) {
            this.custom_styles.splice(i, 1);
            break;
          }
        }
        this.custom_styles.push(obj);
        this.update();
      }
      this.cssPropName = null;
      this.cssPropValue = null;
    },
    update() {
      this.$emit('onChange', this.custom_styles);
    },
    edit(css) {
      if (css) {
        this.cssPropName = css.name;
        this.cssPropValue = css.value;
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
